import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageShell from './PageShell';
import { marketApi } from './api';

export default function MarketsPage() {
  const [overview, setOverview] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    marketApi.overview().then(setOverview).catch((err) => setError(err.message));
  }, []);

  return (
    <PageShell title="Markets" subtitle="Monitor major indexes and movers from a single view." breadcrumbs={[{ label: 'Home' }, { label: 'Markets' }]} activeTab="markets">
      <section className="dashboard-section">
        <h3>Indexes</h3>
        {error && <div className="error-box">{error}</div>}
        {!overview ? (
          <div className="skeleton-list"><span className="skeleton-bar" /></div>
        ) : (
          <div className="watchlist-card-list">
            {overview.indices.map((quote) => (
              <div key={quote.symbol} className="watchlist-card-item">
                <Link to={`/stocks/${quote.symbol}`} className="stock-link strong">{quote.symbol}</Link>
                <div className="watchlist-metric">
                  <strong>${Number(quote.price || 0).toFixed(2)}</strong>
                  <span className={Number(quote.change || 0) >= 0 ? 'up' : 'down'}>
                    {Number(quote.change || 0) >= 0 ? '▲' : '▼'} {Math.abs(Number(quote.changePercent || 0)).toFixed(2)}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      <section className="dashboard-section">
        <h3>Market movers</h3>
        {!overview ? (
          <div className="skeleton-list"><span className="skeleton-bar" /></div>
        ) : (
          <div className="watchlist-card-list">
            {overview.topMovers.map((quote) => (
              <div key={quote.symbol} className="watchlist-card-item">
                <Link to={`/stocks/${quote.symbol}`} className="stock-link strong">{quote.symbol}</Link>
                <div className="watchlist-metric">
                  <strong>${Number(quote.price || 0).toFixed(2)}</strong>
                  <span className={Number(quote.change || 0) >= 0 ? 'up' : 'down'}>
                    {Number(quote.change || 0) >= 0 ? '▲' : '▼'} {Math.abs(Number(quote.changePercent || 0)).toFixed(2)}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </PageShell>
  );
}
